import requestAction from '../utils/requestAction'

export const fetchDiscountList = ( params: string = '' ) =>
  requestAction('DISCOUNT_LIST', params)('discountList', 'GET')
